import React from 'react'
import { Box, Stack } from '@mui/material'

import { Typography } from '~components/internal'
import { spacing } from '~tokens/internal'

import './CardTableRow.scss'

interface CardTableRowProps {
  title: React.ReactNode
  description?: React.ReactNode
  actions: React.ReactNode
}

const CardTableRow: React.FC<CardTableRowProps> = ({ title, description, actions }) => {
  return (
    <Stack spacing={spacing.xxs} className='internal-card-table-row'>
      <Box className='internal-card-table-row__header'>
        {typeof title === 'string' ? <Typography variant='body1'>{title}</Typography> : title}
        {actions}
      </Box>
      {typeof description === 'string' ? <Typography>{description}</Typography> : description}
    </Stack>
  )
}

export default CardTableRow
